import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'update-user-role-popup',
  templateUrl: './update-user-role-popup.html',
  styleUrls: ['./update-user-role-popup.css',
  '../../../../admin-dashboard/common-popup/common-popup.css']
})
export class UpdateUserRolePopup  {
  // `driver` is only a flag ("show in the Delivery > Drivers list"); it grants
  // nothing by itself. Scope and features live server-side in driverUsers.
  roles = ['admin','editor','subscriber','driver'];
  selectedOptions = [];
  selectedOption;
  // objectKeys = Object.keys;

  constructor( public dialogRef: MatDialogRef<UpdateUserRolePopup>,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.selectedOptions  = data['roles']
      console.log(this.selectedOptions)
  }

  onNgModelChange($event) {
    console.log($event);
    this.selectedOption = $event;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
